var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { transition: false, "max-width": 800, persistent: false },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }),
          _c(
            "v-card-text",
            [
              _c("FormEventSchedules", {
                ref: "formEventSchedulesForm",
                attrs: {
                  eventId: _vm.eventId,
                  data: _vm.data,
                  idx: _vm.idx,
                  timezone: _vm.timezone,
                  "is-only-edit": _vm.isOnlyEdit,
                },
                on: {
                  close: _vm.close,
                  "change-event-schedules": function ($event) {
                    return _vm.$emit("change-event-schedules", $event)
                  },
                  delete: function ($event) {
                    return _vm.$emit("delete-event-shedule", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }